import { render, staticRenderFns } from "./AllSubscribers.vue?vue&type=template&id=641efe36&scoped=true"
import script from "./AllSubscribers.vue?vue&type=script&lang=js"
export * from "./AllSubscribers.vue?vue&type=script&lang=js"
import style0 from "./AllSubscribers.vue?vue&type=style&index=0&id=641efe36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641efe36",
  null
  
)

export default component.exports